import React from "react"
import _ from "lodash"
import { DropdownInterface } from 'components/table/inputs/dropdown'

const DropdownField = (props: DropdownInterface) => {
  const currentVal = _.get(props.rowData, props.field)

  if (props.default && _.isNil(currentVal)) {
    props.persist(props.default, props.field, props.rowData)
  }

  return <span>{ _.get(_.find(props.options, i => i.value === currentVal), "label") }</span>
}

export default DropdownField
